import Icon from '@ant-design/icons';
import React from 'react';

interface IconProps {
  icon: any;
  fontSize?: number;
}

export const MenuIcon = (props: IconProps) => (
  <Icon style={{ fontSize: props.fontSize || 18 }} component={props.icon} alt='' />
);
